import { Accordion } from "../../../components/ui/accordion";
import { FaqItem } from "../types";
import { FaqQuestion } from "./faq-question";

interface FaqListProps {
  items: FaqItem[];
}

export function FaqList({ items }: FaqListProps) {
  if (items.length === 0) {
    return (
      <div className="py-8 text-center">
        <p className="text-muted-foreground">
          Selecione uma operação para visualizar as perguntas frequentes.
        </p>
      </div>
    );
  }

  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map((faq, index) => (
        <FaqQuestion
          key={index}
          value={`item-${index}`}
          question={faq.question}
          answer={faq.answer}
        />
      ))}
    </Accordion>
  );
}
